import { CompassLoggers } from '@simplisafe/compass-web'

export const LoggerName = {
  apiQueries: 'apiQueries',
  apiUtils: 'apiUtils',
  ErrorBoundary: 'ErrorBoundary',
  dateUtils: 'dateUtils',
  DetailRow: 'DetailRow',
  LocationSearch: 'LocationSearch',
  DatePickerPage: 'DatePickerPage',
  CameraOverviewPage: 'CameraOverviewPage',
  DocumentPanel: 'DocumentPanel',
  ConfirmationModal: 'ConfirmationModal',
  EmergencyContacts: 'EmergencyContacts',
  usePendingWorkflowStatus: 'usePendingWorkflowStatus',
  SaveAddress: 'SaveAddress',
  MonitoringCertificate: 'MonitoringCertificate',
  ErtPlugin: 'ErtPlugin',
  RRWebPlugin: 'RRWebPlugin',
  BufferingCoordinator: 'BufferingCoordinator',
  VideoMirror: 'VideoMirror',
  BaseVideoPlayer: 'BaseVideoPlayer',
  BaseVideoPlayerListeners: 'BaseVideoPlayerListeners',
  PlaceholderWorkQueue: 'PlaceholderWorkQueue',
  ErtInspect: 'ErtInspect',
  useClipMediaDurations: 'useClipMediaDurations',
  useHtmlVideoPlayerState: 'useHtmlVideoPlayerState',
  InspectPlayerForCamera: 'InspectPlayerForCamera',
  ErtPreprocessor: 'ErtPreprocessor',
  ertUtils: 'ertUtils',
  ErtPlayer: 'ErtPlayer',
  useErtRecordingData: 'useErtRecordingData',
  ReplayerProxy: 'ReplayerProxy',
  ErtHlsPlayer: 'ErtHlsPlayer',
  ErtFlvPlayer: 'ErtFlvPlayer',
  videoMirrorUtils: 'videoMirrorUtils',
  VideoPlaceholdersTracker: 'VideoPlaceholdersTracker',
  SpecialistAudio: 'SpecialistAudio',
  ...CompassLoggers
}
